import React from 'react';
import { connect } from 'react-redux';
import { util_updateRouteName } from '../store/actionsv1/utils';
import { NavigationContainer } from '@react-navigation/native';
import { pageHit } from '../utils/analytics/google';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { createStackNavigator } from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { EventStackParamList, HomeStackParamList, AuthStackParamList, CompetitionStackParamList, SocialStackParamList, PollStackParamList } from '../types'

import HomeScreen from '../screensV1/Home/DashboardScreen';
import EventScreen from '../screensV1/Event/EventsScreen';
import MarketScreen from '../screensV1/Event/MarketScreen';
import InviteFriendsScreen from '../screensV1/Home/InviteFriendsScreen';


//CompetitionStack Screens
//import CompetitionHomeScreen from '../screens/competitionScreens/CompetitionHomeScreen';
//import CompetitionCreateScreen from '../screens/competitionScreens/CompetitionCreateScreen';
//import CompetitionPlayScreen from '../screens/competitionScreens/CompetitionPlayScreen';
import SquaresPlayScreen from '../screensV1/Squares/SquaresPlay';
import NotificationsScreen from '../screensV1/Home/NotificationsScreen';
//import CompetitionLeaderboardScreen from '../screens/competitionScreens/CompetitionLeaderboardScreen';
//import MarketPerformanceScreen from '../screens/homeScreens/MarketPerformanceScreen';
//import CompPerformanceScreen from '../screens/homeScreens/CompPerformanceScreen';
//import TradeHistory from '../screens/marketScreens/TradeHistory';


//Social Screens
import ActivityFeedScreen from '../screensV1/Social/ActivityFeed';
import ActivityDetailScreen from '../screensV1/Social/ActivityDetail';
import SocialProfileScreen from '../screensV1/Social/SocialProfile';
import DirectMessageScreen from '../screensV1/Social/DirectMessage';
import LeagueScreen from '../screensV1/Event/LeagueScreen';
//import CompetitionEnterCodeScreen from '../screens/competitionScreens/CompetitionEnterCodeScreen';
//import LeaderboardScreen from '../screens/socialScreens/LeaderboardScreen';

import { linking } from './linking';
import { Image, View } from 'react-native';
import { Text } from '../globalComponents/NativeOverrides';
import Colors from '../constants/Colorsv2';
import MemoPostScreen from '../screensV1/Social/MemoPostScreen';
import HeaderCard from '../Componentsv1/AppHeader';
//import CompetitionLeaderPicksScreen from '../screens/competitionScreens/CompetitionLeaderPicksScreen';
//import CompetitionSelectScreen from '../screens/competitionScreens/CompetitionSelectScreen';
import { segPageHit } from '../utils/analytics/segment';
//import CompetitionSeasonLeaderboardScreen from '../screens/competitionScreens/CompetitionSeasonLeaderboardScreen';
import { navigationRef } from './RootNavigation';

import OverallMetricScreen from '../screens/AnalyticsScreens/OverallMetricsScreen';
import ActivityMetricsScreen from '../screens/AnalyticsScreens/MarketMetricsScreen';
//import PromotedOrdersScreen from '../screens/marketScreens/PromotedOrdersScreen'; //ADD BACK
import PlayerFollowers from '../screensV1/Social/PlayerFollowers';
import TagsScreen from '../screensV1/Social/TagsScreen';
import AdditionalMarketsScreen from '../screensV1/Event/AdditionalMarketsScreen';
import TournamentScreen from '../screensV1/Event/TournamentScreen';
import TournamentScreen2 from '../screensV1/Event/TournamentScreen2';
import DiscoverHomeScreen from '../screensV1/Discover/DiscoverHomeScreen';
import PodcastsScreen from '../screensV1/Social/Podcasts';
import PodcastEpisodes from '../screensV1/Social/PodcastEpisode2';
import SearchScreen from '../screensV1/Discover/SearchScreen';
import ShareableScreen from '../screensV1/Social/ShareableScreen';
import OrderActivityScreen from '../screensV1/Event/OrderActivity';
import EventOrderScreen from '../screensV1/Event/EventOrderScreen';
import CompetitionHomeScreen from '../screensV1/Comps/CompetitionHomeScreen';
import BetMatch from '../screensV1/Event/BetMatch';
import PlayerFiltersScreen from '../screensV1/Event/PlayerFiltersScreen';
import CompetitionPlayScreen from '../screensV1/Comps/CompetitionPlayScreen2';
import CompetitionSeasonScreen from '../screensV1/Comps/CompetitionSeasonScreen';

import LeaderboardScreen from '../screensV1/Discover/LeaderboardScreen';
import HedgeScreen from '../screensV1/Event/HedgeScreen';
import EventHedgesScreen from '../screensV1/Event/EventHedgesScreen';
import ArticleFeedsScreen from '../screensV1/Social/ArticleFeeds';
import ArticlesScreen from '../screensV1/Social/ArticlesScreen';
import ManageFilterScreen from '../screensV1/Event/ManageFilterScreen';
import PlayerLeadersScreen from '../screensV1/Social/PlayerLeadersScreen';
import BracketPlayScreen from '../screensV1/Brackets/BracketPlayScreen2';
import store from '../store';
import { V1_UPDATE_LAST_ROUTE } from '../store/actionsv1/types';
import PollReviewScreen from '../screensV1/Polls/PollReviewScreen';
import StoreScreen from '../screensV1/Discover/StoreScreen';
import HeadtoHeadScreen from '../screensV1/Social/HeadtoHeadScreen';
import { DashboardIcon, DiscoverIcon, PulseIcon, SocialIcon, Trophy } from '../Componentsv1/Icons';
import ActivityRebatesScreen from '../screensV1/Home/ActivityRebatesScreen';
import ActivityRebateScreen from '../screensV1/Home/ActivityRebateScreen';
import { BEEventApi } from 'be-components';
import PremiumScreen from '../screensV1/Auth/PremiumScreen';
import AuthenticateScreen from '../screensV1/Auth/AuthenticateScreen';
import TeamScreen from '../screensV1/Event/TeamScreen';
import CompanyScreen from '../screensV1/Social/CompanyScreen';

const HomeStack = () => {
  const MyStack = createStackNavigator<HomeStackParamList>()
  return (
    <MyStack.Navigator 

    screenOptions={{
      headerShown: true,
      header: props => <HeaderCard {...props} />
    }}>
      <MyStack.Screen name='Dashboard' component={HomeScreen} options={{ header: props => <HeaderCard {...props} backVisible={false} /> }}/> 
      <MyStack.Screen name='ActivityRebates' component={ActivityRebatesScreen} options={{ header: props => <HeaderCard {...props} backVisible={true} /> }}/> 
      <MyStack.Screen name='ActivityRebate' component={ActivityRebateScreen} options={{ header: props => <HeaderCard {...props} backVisible={true} /> }}/> 
      <MyStack.Screen name='Notification' component={NotificationsScreen} options={{ header: props => <HeaderCard {...props} backVisible={true} /> }}/>
      <MyStack.Screen name='InviteFriends' component={InviteFriendsScreen} options={{ header: props => <HeaderCard {...props} backVisible={true} /> }}/> 
      <MyStack.Screen name='OverallMetrics' component={OverallMetricScreen} options={{ header: props => <HeaderCard {...props} backVisible={true} /> }}/>
      <MyStack.Screen name='ActivityMetrics' component={ActivityMetricsScreen} options={{ header: props => <HeaderCard {...props} backVisible={true} /> }}/>
    </MyStack.Navigator>
  )
}



const AuthStack = (props:any) => { 
  const MyStack = createStackNavigator<AuthStackParamList>()
  const { isOnboarded, isAuthenticated, insets, appHeight } = props

  return (
    <MyStack.Navigator 
    
    screenOptions={{
      headerShown: false,
    }}>
      <MyStack.Screen name='Authenticate' children={(p) => <AuthenticateScreen {...p} appHeight={appHeight} insets={insets}/>}/>
      <MyStack.Screen name='Premium' children={(p) => <PremiumScreen {...p} appHeight={appHeight} insets={insets}/>}/>
      
    </MyStack.Navigator>
  ) 
}

const EventStack = (props:any) => { 
  const MyStack = createStackNavigator<EventStackParamList>()
  return (
    <MyStack.Navigator 
    
    screenOptions={{
      animationEnabled:true,
      presentation: 'transparentModal',
      headerShown: true,
    }}>
      <MyStack.Screen name='Events' component={EventScreen} options={{ header: props => <HeaderCard {...props} backVisible={false} /> }}/>
      <MyStack.Screen name='BetMatch' component={BetMatch} options={{ header: props => <HeaderCard {...props} backVisible={true} /> }}/>
      <MyStack.Screen name='Tournament' component={TournamentScreen} options={{ header: props => <HeaderCard {...props} backVisible={true} /> }}/>
      <MyStack.Screen name='Tournament2' component={TournamentScreen2} options={{ header: props => <HeaderCard {...props} backVisible={true} /> }}/>

      <MyStack.Screen name='Market' component={MarketScreen} options={{ header: props => <HeaderCard {...props} backVisible={true} /> }}/>
      <MyStack.Screen name='AdditionalMarkets' component={AdditionalMarketsScreen} options={{ header: props => <HeaderCard {...props} backVisible={true} /> }}/>
      {props.isAuthenticated ?
      <>
      <MyStack.Screen name='EventOrders' component={EventOrderScreen} options={{ header: props => <HeaderCard {...props} backVisible={true} /> }}/>
      <MyStack.Screen name='EventHedges' component={EventHedgesScreen} options={{ header: props => <HeaderCard {...props} backVisible={true} /> }}/>
      <MyStack.Screen name='Hedge' component={HedgeScreen} options={{ header: props => <HeaderCard {...props} backVisible={true} /> }}/>
      <MyStack.Screen name='OrderActivity' component={OrderActivityScreen} options={{ header: props => <HeaderCard {...props} backVisible={true} /> }}/>
      <MyStack.Screen name='PlayerFilters' component={PlayerFiltersScreen} options={{ header: props => <HeaderCard {...props} backVisible={true} /> }}/>
      <MyStack.Screen name='ManageFilter' component={ManageFilterScreen} options={{ header: props => <HeaderCard {...props} backVisible={true} /> }}/>

      </>
      :<></>}

      <MyStack.Screen name='League' component={LeagueScreen} options={{ header: props => <HeaderCard {...props} backVisible={true} /> }}/>
      <MyStack.Screen name='Team' component={TeamScreen} options={{ header: props => <HeaderCard {...props} backVisible={true} /> }}/>

      
    </MyStack.Navigator>
  ) 
}

const PollStack = (props:any) => { 
  const MyStack = createStackNavigator<PollStackParamList>()
  const { isOnboarded, isAuthenticated, insets, appHeight } = props

  return (
    <MyStack.Navigator 

    screenOptions={{
      headerShown: false,
    }}>
      <MyStack.Screen name='PollReview' children={(p) => <PollReviewScreen {...p} appHeight={appHeight} insets={insets}/>}/>
    </MyStack.Navigator>
  ) 
}


const CompetitionStack = (props:any) => { 
  const MyStack = createStackNavigator<CompetitionStackParamList>()
  return (
    <MyStack.Navigator 

    screenOptions={{
      headerShown: true,
      animationEnabled:true,
      presentation: 'transparentModal'
    }}>
      <MyStack.Screen name='CompetitionHome' component={CompetitionHomeScreen} options={{ header: props => <HeaderCard {...props} backVisible={false} /> }}/>
      <MyStack.Screen name='CompetitionPlay' component={CompetitionPlayScreen} options={{ header: props => <HeaderCard {...props} backVisible={true} /> }}/>
      <MyStack.Screen name='CompetitionSeason' component={CompetitionSeasonScreen} options={{ header: props => <HeaderCard {...props} backVisible={true} /> }}/>
      <MyStack.Screen name='SquaresPlay' component={SquaresPlayScreen} options={{ header: props => <HeaderCard {...props} backVisible={true} /> }}/>
      <MyStack.Screen name='BracketPlay' component={BracketPlayScreen} options={{ headerShown:false }}/>
    </MyStack.Navigator>
  ) 
}


const SocialStack = (props:any) => { 
  const MyStack = createStackNavigator<SocialStackParamList>()
  return (
    <MyStack.Navigator 

    screenOptions={{
      animationEnabled:true,
      presentation: 'transparentModal',
      headerShown: true
    }}>
      <MyStack.Screen name='ActivityFeed' component={ActivityFeedScreen} options={{ header: props => <HeaderCard {...props} backVisible={false} /> }}/>
      <MyStack.Screen name='ActivityDetail' component={ActivityDetailScreen} options={{ header: props => <HeaderCard {...props} backVisible={true} /> }}/>
      <MyStack.Screen name='Podcasts' component={PodcastsScreen} options={{ header: props => <HeaderCard {...props} backVisible={true} /> }}/>
      <MyStack.Screen name='ArticleFeeds' component={ArticleFeedsScreen} options={{ header: props => <HeaderCard {...props} backVisible={true} /> }}/>
      <MyStack.Screen name='Articles' component={ArticlesScreen} options={{ header: props => <HeaderCard {...props} backVisible={true} /> }}/>
      <MyStack.Screen name='PodcastEpisodes' component={PodcastEpisodes} options={{ headerShown:false }}/>

      {props.isAuthenticated ?
            <>
            <MyStack.Screen name='Tags' component={TagsScreen} options={{ header: props => <HeaderCard {...props} backVisible={true} /> }}/>
            <MyStack.Screen name='DirectMessage' component={DirectMessageScreen} options={{ headerShown:false }}/>
            <MyStack.Screen name='H2H' component={HeadtoHeadScreen} options={{ header: props => <HeaderCard {...props} backVisible={true} /> }}/>
            <MyStack.Screen name='MemoPost' component={MemoPostScreen} options={{ headerShown:false }}/>
            <MyStack.Screen name='PlayerFollowers' component={PlayerFollowers} options={{ header: props => <HeaderCard {...props} backVisible={true} /> }}/>
            <MyStack.Screen name='Shareable' component={ShareableScreen} options={{ header: props => <HeaderCard {...props} backVisible={true} /> }}/>
            <MyStack.Screen name='PlayerLeaders' component={PlayerLeadersScreen} options={{ header: props => <HeaderCard {...props} backVisible={true} /> }}/>
            </>
      :<></>}
      <MyStack.Screen name='SocialProfile' component={SocialProfileScreen} options={{ headerShown:false }}/>
      <MyStack.Screen name='CompanyProfile' component={CompanyScreen} options={{ headerShown:false }}/>
    </MyStack.Navigator>
  ) 
}

const DiscoverStack = (props:any) => { 
  const MyStack = createStackNavigator<SocialStackParamList>()
  return (
    <MyStack.Navigator 

    screenOptions={{
      animationEnabled:true,
      presentation: 'transparentModal',
      headerShown: true
    }}>
      <MyStack.Screen name='Discover' component={DiscoverHomeScreen} options={{ header: props => <HeaderCard {...props} backVisible={false} /> }}/>
      <MyStack.Screen name='Leaderboard' component={LeaderboardScreen} options={{ header: props => <HeaderCard {...props} backVisible={true} /> }}/>
      <MyStack.Screen name='Search' component={SearchScreen} options={{ header: props => <HeaderCard {...props} backVisible={true} /> }}/>
      <MyStack.Screen name='Store' component={StoreScreen} options={{ header: props => <HeaderCard {...props} backVisible={true} /> }}/>
    </MyStack.Navigator>
  ) 
}




const TabNav = (props: any) => {
  const MyTabs = createBottomTabNavigator();

  return (
      <MyTabs.Navigator 
      id={'MyTabs'}
      
      initialRouteName='EventStack'
      backBehavior='none'
      screenOptions={{
        tabBarStyle: { backgroundColor:Colors.brand.midnight },
        tabBarShowLabel: false,
        header: () => <View style={{ height:0, backgroundColor:props.isAuthenticated&&props.market_type==='FREE'?Colors.brand.cyan:Colors.brand.electric }} />,
      }}>
          <MyTabs.Screen 
            name="SocialStack" 
            options={{ 
              title: 'Social', 
              tabBarIcon: ({ color, size, focused }) => (
                <View nativeID='social-trigger' style={{ alignItems:'center'}}>
                  <SocialIcon size={17} color={color} />
                  <Text style={{ marginTop:4 }} color={color} size={10} weight='regular' textAlign='center'>SOCIAL</Text>
                </View>
              ) 
            }} 
            children={(p) => <SocialStack {...p} isAuthenticated={props.isAuthenticated}/>}
          />

          <MyTabs.Screen 
            name="EventStack" 
            options={{ 
              title: 'Markets',
              tabBarIcon: ({ color, size, focused }) => (
                <View nativeID='markets-trigger' style={{ alignItems:'center'}}>
                  <PulseIcon size={17} color={color} />
                  <Text style={{ marginTop:4 }} color={color} size={10} weight='regular' textAlign='center'>MARKETS</Text>
                </View>
              ) 
            }} 
            children={(p) => <EventStack {...p} isAuthenticated={props.isAuthenticated}/>}
          />
          {props.isAuthenticated ?
          <MyTabs.Screen 
            name="DiscoverStack" 
            options={{ 
              title: 'Discover',
              tabBarIcon: ({ color, size, focused }) => (
                <View nativeID='dashboard-trigger' style={{ alignItems:'center'}}>
                  <DiscoverIcon size={17} color={color} />
                  <Text style={{ marginTop:4 }} color={color} size={10} weight='regular' textAlign='center'>DISCOVER</Text>
                </View>
              )
            }} 
            children={(p) => <DiscoverStack {...p} isAuthenticated={props.isAuthenticated}/>}
          />
          :<></>}

          <MyTabs.Screen 
            name="CompetitionStack" 
            options={{ 
              title: 'Competition',
              tabBarIcon: ({ color, size, focused }) => (
                <View nativeID={'comps-trigger'} style={{ alignItems:'center'}}>
                  <Trophy size={17} color={color} />
                  <Text style={{ marginTop:4 }} color={color} size={10} weight='regular' textAlign='center'>COMPS</Text>
                </View>
              ) 
            }} 
            children={(p) => <CompetitionStack {...p} isAuthenticated={props.isAuthenticated}/>}
          />
          {props.isAuthenticated?
          <MyTabs.Screen 
            name="HomeStack"
            component={HomeStack} 
            options={{ 
              title: 'Home',
              tabBarIcon: ({ color, size, focused }) => (
                <View nativeID='dashboard-trigger' style={{ alignItems:'center'}}>
                  <DashboardIcon size={17} color={color} />
                  <Text style={{ marginTop:4 }} color={color} size={10} weight='regular' textAlign='center'>DASHBOARD</Text>
                </View>
              ) 
            }}
          />
          :<></>}
      </MyTabs.Navigator>
  )
}

const MainNav = ( props:any ) => {
  
  const routeNameRef = React.useRef();
  const MyStack = createStackNavigator()
  const insets = useSafeAreaInsets()
  return (
    <NavigationContainer 
    fallback={<></>}
    ref={navigationRef}
    onReady={() => {
      let current_route = navigationRef.current.getCurrentRoute().name
      let path = navigationRef.current.getCurrentRoute().path
      routeNameRef.current = current_route
      let player_id = store.getState().player.player?.player_id
      pageHit(path, current_route, player_id);
      segPageHit(current_route)
      BEEventApi.pageHit(current_route, path)
      store.dispatch({ type: V1_UPDATE_LAST_ROUTE, current_route: { route:current_route } })

    }}
    onStateChange={(e) => {
      const previousRouteName = routeNameRef.current;
      const currentRouteName = navigationRef.current.getCurrentRoute().name
      const currentPath = navigationRef.current.getCurrentRoute().path
      if(previousRouteName !== currentRouteName){
        let player_id = store.getState().player.player?.player_id
        pageHit(currentPath, currentRouteName, player_id)
        segPageHit(currentRouteName)
        BEEventApi.pageHit(currentRouteName, currentPath)

        //util_updateRouteName(currentRouteName)
        routeNameRef.current = currentRouteName
      }
      let parent_stack, parent_stack_state, child_stack, child_stack_state, screen;
      if(e){
        parent_stack = e.routes[e.index]
        if(parent_stack){
          parent_stack_state = parent_stack.state
        }
        if(parent_stack_state){
            child_stack = parent_stack_state.routes[parent_stack_state.index]
        }
        if(child_stack){
          child_stack_state = child_stack.state
        }
        if(child_stack_state){
          screen = child_stack_state.routes[child_stack_state.index]
        }
      }
      store.dispatch({ type: V1_UPDATE_LAST_ROUTE, current_route: { route:currentRouteName, stack_key: child_stack?.key, key: screen?.key, params: screen?.params } })
    }}
    linking={linking}>
    <MyStack.Navigator 
      screenOptions={{
      headerShown: false
    }}>
      <MyStack.Screen name="Auth" children={(p) => <TabNav {...p} isAuthenticated={props.isAuthenticated}/>}/>
      <MyStack.Screen name='PollStack' children={(p) => <PollStack {...p} isAuthenticated={props.isAuthenticated} insets={insets} isOnboarded={props.isOnboarded} appHeight={props.appHeight}/>} />
      <MyStack.Screen name='AuthStack' children={(p) => <AuthStack {...p} isAuthenticated={props.isAuthenticated} insets={insets} isOnboarded={props.isOnboarded} appHeight={props.appHeight}/>} />
    </MyStack.Navigator>
    </NavigationContainer>
  )
}

//Redux Store Functions
const mapStateToProps = (state: any) => {
  return {
    isAuthenticated: state.util.auth_tokens?.authenticated,
    isOnboarded: state.auth.isOnboarded,
    routeName: state.pref.routeName
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    util_updateRouteName: (routeName:string) => dispatch(util_updateRouteName(routeName))
  }
}

export default React.memo(connect(mapStateToProps, mapDispatchToProps)(MainNav))


